const BASEURL = "https://crm.microworldinfosol.com:5000";

export default BASEURL;
